import { FavouriteDefinition, ReportDefinition } from 'app/types-shared';

export const updateSelectedReport = (definition: FavouriteDefinition, fieldsToUpdate: Partial<ReportDefinition>) => {
  const selectedReport = definition.reports.find(r => r.report.v === definition.selectedReport.v);

  return selectedReport ? {
    ...definition,
    reports: definition.reports.map(r => r.report.v === definition.selectedReport.v
      ? {
        ...selectedReport,
        ...fieldsToUpdate
      }
      : r)
  } : definition;
};

export const transformSelectedReport = (
  reportFieldsToUpdate: Partial<ReportDefinition>
) =>
  (workingDefinition: FavouriteDefinition): FavouriteDefinition => {
    return updateSelectedReport(workingDefinition, reportFieldsToUpdate);
  };
